import { render } from "./view_all_leader.vue?vue&type=template&id=8f2a8b7e"
import script from "./view_all_leader.vue?vue&type=script&lang=js"
export * from "./view_all_leader.vue?vue&type=script&lang=js"

import "./view_all_leader.vue?vue&type=style&index=0&id=8f2a8b7e&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__